export default __webpack_public_path__ + "static/media/img.18588cb5.png";